import { render, staticRenderFns } from "./OrderDetailsDialog.vue?vue&type=template&id=2ee9ee16&scoped=true"
import script from "./OrderDetailsDialog.vue?vue&type=script&lang=js"
export * from "./OrderDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsDialog.vue?vue&type=style&index=0&id=2ee9ee16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee9ee16",
  null
  
)

export default component.exports